export interface IMailSurvey {
  contactId: string;
  q1: number;
  q2: number;
  q3: number;
  q4: number;
  q5: number;
  q6: number;
  q7: number;
  q8: number;
  q9: number;
  q10: number;
  q11: number;
  comments: string;
}

export class MailSurveyModel {
  Survey: IMailSurvey;
  EndPointURL: string;
  Token: string;
}



// WEBPACK FOOTER //
// ./src/app/genericpages/mailsurvey/MailSurvey.ts